import Vue from 'vue'
import ToastComponent from './index.vue'

const Toast = {}
let toastNode = null // 存储toast节点元素

Toast.install = function (Vue) {
  const ToastConstructor = Vue.extend(ToastComponent)
  if (toastNode) return;
  toastNode = new ToastConstructor()
  toastNode.$mount() // 挂载实例，为了获取下面的toastNode.$el
  document.body.appendChild(toastNode.$el)

  Vue.prototype.$toast = function (msg, timer, mask) {
    toastNode.content = msg
    toastNode.visible = true
    toastNode.maskVisible = mask?mask:toastNode.maskVisible
    timer = timer && timer > 0 ? timer : toastNode.timer
    setTimeout(function(){
      toastNode.visible = false
    },timer)
  }
}

export default Toast




// WEBPACK FOOTER //
// ./src/components/common-components/features/toast/index.js